import axiosClient from '../axiosClient';

export const getInviteSettings = () => axiosClient.get('/invite/settings');
export const updateInviteSettings = (data) => axiosClient.put('/invite/settings', data);
export const sendInvite = (data) => axiosClient.post('/invite/send', data);
